<template>
  <main class="page-projects page-update-project-module-visea p-0 d-flex flex-column">
    <div class="nav-container">
      <div class="container">
        <ul class="nav nav-pills nav-fill">
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'projects.show' }">Dati</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'projects.edit' }">Modifica</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link active" :to="{ name: 'projects.visea' }" aria-current="page">Modulo ViSEA</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'projects.visea.graph' }">Modulo ViSEA (Grafo)</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'projects.tutorial' }">Tutorial</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div ref='page' class="flex-grow-1 container-fluid overflow-hidden pt-3 px-0 d-flex flex-column justify-content-between">
      <canvas ref='can'></canvas>
      <div class="mode-box d-flex p-3 justify-content-center bg-white">
        <template v-if="null === mode">
          <button class="btn btn-secondary mx-2 " @click.prevent="pickMode('add')">Modalità Aggiungi</button>
          <button class="btn btn-secondary mx-2" @click.prevent="pickMode('edit')">Modalità Modifica</button>
          <button class="btn btn-secondary mx-2" @click.prevent="pickMode('delete')">Modalità Elimina</button>
          <button class="btn btn-secondary mx-2" @click.prevent="pickMode('overlay')">Modalità Sovrapposizioni</button>
          <button class="btn btn-primary font-weight-bold mx-2" @click.prevent="saveEditorData">Salva</button>
        </template>
        <template v-else>
          <p class="h2 mb-0 mr-4">
            <template v-if="mode === 'add'">Modalità Aggiungi</template>
            <template v-else-if="mode === 'edit'">Modalità Modifica</template>
            <template v-else-if="mode === 'delete'">Modalità Elimina</template>
            <template v-else-if="mode === 'overlay'">Modalità Sovrapposizioni</template>
          </p>
          <button class="btn btn-danger" @click.prevent="exitMode">Esci dalla modalità</button>
        </template>
      </div>
    </div>
  </main>
</template>

<script>

import { visea } from '@/libs/Editor/visea';
import $api from '@/libs/OAuth2/services/api';
import validateMixin from '@/libs/Form/mixins/validate';
import confirmWithModalMixin from '@/libs/Confirm/mixins/confirmWithModal';

export default {
  name: 'module-edit',
  mixins: [validateMixin, confirmWithModalMixin],
  components: {
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      feedback: null,
      mode: null,
      projectData: {
        visea_module: null,
      },
      visea: visea,
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.can.width = this.$refs.page.clientWidth;
      this.$refs.can.height = this.$refs.page.clientHeight;
      visea.internals.editorMode = visea.EDITOR_VISEA;
      visea.internals.useRender = true;
      visea.internals.callbacks.onPolygonDelete = this.confirm;
      window.$visea = visea;
      window.$vm = this;
      visea.initCanvas(this.$refs.can);
      // console.log(this.projectData);
      visea.util.addLayer(0, '#FF0000');
      visea.loadImg(this.project?.image?.url).finally(() => {
        visea.util.importSession(this.projectData.visea_module);
        visea.callbacks.hook();
        visea.util.switchMode(visea.NORMAL_MODE);
        this.mode = null;
      });
    });
  },
  methods: {
    confirmDelete () {
      return this.confirm('Eliminare poligono?');
    },
    removeFieldError (field) {
      this.removeFeedback();
      this.removeError(field);
    },
    removeFeedback () {
      this.feedback = null;
    },
    isValid () {
      this.clearErrors();
      this.removeFeedback();

      return !this.hasErrors;
    },
    saveEditorData () {
      this.clearErrors();
      this.removeFeedback();

      if (!this.isValid()) {
        return;
      }

      this.projectData = {
        visea_module: visea.util.exportSession(),
      };

      this.$api.updateProjectModuleVisea(this.project.id, this.projectData)
        .then(() => {
          this.$router.push({ name: 'projects.show' });
        })
        .catch(err => {
          this.$log.error(err);
          this.feedback = false;
        })
      ;
    },
    pickMode (mode) {
      if (this.mode !== null) {
        return;
      }

      this.mode = mode;
      if (mode === 'add') {
        this.visea.util.switchMode(visea.NEW_MODE);
        return;
      }

      if (mode === 'edit') {
        this.visea.util.switchMode(visea.EDIT_MODE);
        return;
      }

      if (mode === 'delete') {
        this.visea.util.switchMode(visea.DELETE_MODE);
        return;
      }

      if (mode === 'overlay') {
        this.visea.util.switchMode(visea.ADJ_MODE);
      }
    },
    exitMode () {
      visea.util.switchMode(visea.NORMAL_MODE);
      this.mode = null;
    },
  },
  beforeRouteEnter (to, from, next) {
    const id = to.params?.id;
    if (!id) {
      return next(from);
    }

    $api.fetchProjectViseaModule(id)
      .then(res => res.data)
      .then(data => {
        if (!data) {
          return next(from);
        }

        next(vm => {
          vm.projectData = data;
        });
      })
      .catch(() => next(from))
    ;
  },
};

</script>

<style lang="scss">
.mode-box {
  z-index: 1;
  box-shadow: 0px 0px 50px rgba($body-color,.35);
}

.canvas-container {
  margin: 0 auto;
}
</style>
